module.exports = __webpack_public_path__ + "img/zuppa-contadina.59a1a09a.png";